import {
  //FETCH_COUNTRY_SUCCESS_ACTION,
  FETCH_CNTRY_CRNCY_SUCCESS_ACTION,
  FETCH_DISTRICTBYID_SUCCESS_ACTION,
  FETCH_LICENSEE_SUCCESS_ACTION,
  FETCH_STATES_SUCCESS_ACTION,
  FETCH_DISTRICTBYID_FAIL_ACTION,
  CLEAR_DISTRICTBYID_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CNTRY_CRNCY_SUCCESS_ACTION:
      return {
        ...state,
        cntrycrncyList: action.payload.rows,
        cntrycrncyListCount: action.payload.count
      };

    case FETCH_STATES_SUCCESS_ACTION:
      return {
        ...state,
        statesList: action.payload
      };

    case FETCH_DISTRICTBYID_SUCCESS_ACTION:
      // console.log(action.payload);
      return {
        ...state,
        districtById: action.payload.rows
      };

    case FETCH_DISTRICTBYID_FAIL_ACTION:
      console.log(action.payload);
      return {
        ...state,
        districtById: []
      };

    case CLEAR_DISTRICTBYID_ACTION:
      return {
        ...state,
        districtById: []
      };

    case FETCH_LICENSEE_SUCCESS_ACTION:
      return {
        ...state,
        LicenseeList: action.payload.rows,
        LicenseeCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
